import api from '@/api';

const state = {
  dataNeedsUpdate: { timestamp: 0, refresh: false },
  updatedApplication: { timestamp: 0, application: null },
  interviewsNeedUpdate: 0,
  recruiterChanged: 0,
  sourcers: [],
  recruiters: null,
  stages: [],
  users: [],
  skills: [],
  countries: [],
  industries: [],
  skillStacks: [],
  rejectionReasons: [],
};

const getters = {};

const actions = {
  async getRecruiters({ commit, state }) {
    if (!state.recruiters) {
      const { data: recruiters } = await api.users.recruiters();
      commit('setRecruiters', recruiters.data);
    }
  },
  async getSkillStacks({ commit, state }) {
    if (!state.skillStacks.length) {
      const { data: skillStacks } = await api.data.skillStacks();
      commit('setSkillStacks', skillStacks.data);
    }
  },
};

const mutations = {
  setSkills(state, skills) {
    state.skills = skills;
  },
  setCountries(state, countries) {
    state.countries = Object.values(countries);
  },
  setIndustries(state, industries) {
    state.industries = industries;
  },
  setSkillStacks(state, skillStacks) {
    state.skillStacks = skillStacks;
  },
  setDataNeedsUpdate(state, refresh = false) {
    state.dataNeedsUpdate = { timestamp: Date.now(), refresh };
  },
  setUpdatedApplication(state, application) {
    state.updatedApplication = { timestamp: Date.now(), application };
  },
  setInterviewsNeedUpdate(state) {
    state.interviewsNeedUpdate = Date.now();
  },
  setRecruiterChanged(state) {
    state.recruiterChanged = Date.now();
  },
  setSourcers(state, values) {
    state.sourcers = values;
  },
  setRecruiters(state, values) {
    state.recruiters = values;
  },
  setStages(state, values) {
    state.stages = values;
  },
  setUsers(state, values) {
    state.users = values;
  },
  setRejectionReasons(state, values) {
    state.rejectionReasons = values;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
